import { render } from "./CuratorTable.vue?vue&type=template&id=097db588&scoped=true"
import script from "./CuratorTable.vue?vue&type=script&lang=js"
export * from "./CuratorTable.vue?vue&type=script&lang=js"

import "./CuratorTable.vue?vue&type=style&index=0&id=097db588&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097db588"]])

export default __exports__